<template>
<div class="chapter">
<div class="inner_page">
<h1 class="TOC-FBMHD">Contents</h1>
<h2 class="TOCCT"><a href="#/c01">Rail Fence</a></h2>
<h2 class="TOCCT"><a href="#/c02">Honey Bee</a></h2>
<h2 class="TOCCT"><span href="#/c03" title="Link target outside of Sample">Trip Around the World</span></h2>
<h2 class="TOCCT"><span href="#/c04" title="Link target outside of Sample">Log Cabin</span></h2>
<h2 class="TOCCT"><span href="#/c05" title="Link target outside of Sample">Maple Leaf</span></h2>
<h2 class="TOCCT"><span href="#/c06" title="Link target outside of Sample">Quick Triangles</span></h2>
<h2 class="TOCCT"><span href="#/c07" title="Link target outside of Sample">Spider’s Web</span></h2>
<h2 class="TOCCT"><span href="#/c08" title="Link target outside of Sample">Tumbling Blocks</span></h2>
<h2 class="TOCCT"><span href="#/c09" title="Link target outside of Sample">Dresden Plate</span></h2>
<p class="TOC-CH-SUB"><span href="#/bm" title="Link target outside of Sample">All full size templates can be found at</span> <a href="http://www.stitchcraftcreate.co.uk/patterns" target="_blank">www.stitchcraftcreate.co.uk/patterns</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?409625e7